import type { HealthStatus } from '../../finance';

export const TONE: Record<HealthStatus, { text: string; bar: string; chip: string; label: string }> = {
  good: { text: 'text-good', bar: 'bg-good', chip: 'bg-good-soft text-good', label: 'Tốt' },
  warn: { text: 'text-warn', bar: 'bg-warn', chip: 'bg-warn-soft text-warn', label: 'Cần chú ý' },
  bad: { text: 'text-bad', bar: 'bg-bad', chip: 'bg-bad-soft text-bad', label: 'Cần xử lý' }
};

export const fmtHealthValue = (key: string, v: number) =>
  key === 'emergency' ? `${v.toFixed(1).replace('.', ',')} tháng`
    : key === 'leverage' ? `${Math.round(v * 100)}%`
    : `${v.toFixed(1).replace('.', ',')}%`;

export function Ring({ score, status }: { score: number | null; status: HealthStatus | null }) {
  const r = 42, c = 2 * Math.PI * r;
  const pct = score ?? 0;
  return (
    <div className="relative h-28 w-28 shrink-0" role="img" aria-label={score === null ? 'Chưa đủ dữ liệu' : `Điểm sức khoẻ ${score} trên 100`}>
      <svg viewBox="0 0 100 100" className="h-full w-full -rotate-90">
        <circle cx="50" cy="50" r={r} fill="none" strokeWidth="9" className="stroke-muted" />
        {score !== null && (
          <circle cx="50" cy="50" r={r} fill="none" strokeWidth="9" strokeLinecap="round"
            strokeDasharray={c} strokeDashoffset={c * (1 - pct / 100)}
            className="transition-[stroke-dashoffset] duration-700"
            style={{ stroke: status ? `hsl(var(--${status}))` : undefined }} />
        )}
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="num text-3xl font-semibold">{score ?? '—'}</span>
        <span className="text-xs text-muted-foreground">/ 100</span>
      </div>
    </div>
  );
}

